
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 220.78 35.8"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"レイヤー 2"}},[_c('path',{attrs:{"d":"M73.46 34h-5.6V4.6H99.3V34zm0-4.88H93.7V9.48H73.46zM130.22 11.68h-13a32.26 32.26 0 01-7.76 11.16l-3.8-3.24a29.51 29.51 0 005.7-7.9 27.82 27.82 0 002.78-9.1l5.2.28a32.08 32.08 0 01-.64 4h14q-1.2-2.32-2.32-4.4L134.14.6q1.64 3.08 3 5.88L136 7v.4q0 14-6.36 20.6t-20.44 7.8l-.8-4.8q11.12-1.08 16.1-5.4t5.72-13.92zM143.34 6l-3.84 1.84q-2.16-4.16-3.12-5.92L140.22 0q1.84 3.36 3.12 6zM147 17.68a55.76 55.76 0 0016.5-5 47.86 47.86 0 0013.42-9.22l3.28 3.76a50.66 50.66 0 01-11.56 8.4v20h-5.74V18.4a60.34 60.34 0 01-15 4.2zM188.7 8.48l2.56-4.8q6 2.88 12.4 6.44L201 14.84q-5.38-3-12.3-6.36zm27-1l5.08 1.12q-2.12 11.88-9.6 18.28t-20.8 7.56l-.8-5.2q11.6-1.12 17.82-6.34t8.3-15.38z"}}),_c('path',{attrs:{"d":"M56.84 2.21H1.54a.9.9 0 00-.9.9v31a.9.9 0 00.9.9h41.74v-2.48h0v-3.28h1.28l1.72 4 1.83-4h1.25v3.28h0V35h7.48a.9.9 0 00.9-.9v-31a.9.9 0 00-.9-.89z","stroke-width":"1.27","fill":"none","stroke":"#000","stroke-miterlimit":"10"}}),_c('path',{attrs:{"stroke-width":"1.16","fill":"none","stroke":"#000","stroke-miterlimit":"10","d":"M18.9 31.76H3.82V5.47H18.9z"}}),_c('path',{attrs:{"d":"M33.06 18.61L22.82 12.7v11.82l10.24-5.91zM36.32 11.77h6.87v6.13h-6.87zM45.73 11.77h8.61v11.77h-8.61z"}})])])
          )
        }
      }
    